import api from '@/services/ApiService';
import { useState } from 'react';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

function selectDefaultReport(reports) {
  if (!reports || reports.length === 0) {
    return null;
  }

  const hourlyReports = reports.filter(
    (report) => report.interval === 'HOURLY',
  );

  const collection = hourlyReports.length > 0 ? hourlyReports : reports;

  return collection.reduce((latest, current) => {
    return new Date(current.timeStart) > new Date(latest.timeStart)
      ? current
      : latest;
  }, collection[0]);
}

export default function CallcenterLayout() {
  const [reports, setReports] = useState([]);
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReports = () =>
      api.get('/report').then(({ data: reportsResponse }) => {
        const fetchedReports = reportsResponse.result || [];
        setReports(fetchedReports);
        setReport((prev) => prev ?? selectDefaultReport(fetchedReports));
      });

    fetchReports().finally(() => {
      setLoading(false);
    });
  }, []);

  return <Outlet context={{ reports, report, setReport, loading }} />;
}
